import { ApiConstant } from "../constants";
import axios from "axios";
/**
 * Check and log if user exists as part of external sourcing
 */
export function checkAndSaveExternalSourcing(formData) {
  const header = {
    "Content-Type": "application/json",
  };
  return axios.post(
    ApiConstant.BASE_URL + ApiConstant.SAVE_EXTERNAL_SOURCING_DATA,
    formData,
    header
  );
}

/**
 * Gets job information to show on the external sourcing page
 * @param {string} token
 */
export function getJobInfo(token) {
  const header = {
    "Content-Type": "application/json",
  };
  return axios.get(
    ApiConstant.BASE_URL + ApiConstant.GET_JOB_INFO + '/'+ token,
    header
  );
}


/**
 * Log page open for external sourcing
 */
export function logPageOpen(token) {
  const header = {
    "Content-Type": "application/json",
  };
  return axios.get(
    ApiConstant.BASE_URL + ApiConstant.SAVE_PAGE_OPEN_LOG + '/'+ token,
    header
  );
}

 
